import { useEffect, useState } from "react";
import fetchAPI from "../../../common/fetchAPI";
import { t } from "i18next";
import { ShowToast } from "../../../common/Toastr";
import Loader from '../../../common/Loader';
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { sortData, getValueFromResource } from "../../../common/timeLiveFunction";

const initialSortValues = {
    sortOrder: 'asc',
    sortColumn: 'SystemEMailNotification'
}

const ProjectEmailNotificationPreferences = (props: any) => {
    const { AccountProjectId } = props;
    const dispatch = useAppDispatch();
    const [emailNotification, setemailNotification] = useState<any | ''>([]);
    const [isLoading, setIsLoading] = useState(true);
    // const [isEmailVerified, setIsEmailVerified] = useState(false);
    const { sessionAccountId } = useAppSelector((state) => state.globalState);
    const [clientSideSorting, setClientSideSorting] = useState<any | ''>(initialSortValues);
    const { isEmailVerified } = useAppSelector((state) => state.globalState);

    useEffect(() => {
        renderEmailNotificationForProject();
    }, []);

    const renderEmailNotificationForProject = async () => {
        try {
            const response = await fetchAPI(`api/V2/EmailNotifications/GetEmailNotificationPreferencessByAccountProjectId/${AccountProjectId}`, 'Get', '', true);
            const json = await response.json();
            //setemailNotification(json);
            if (json.length > 0) {
                setemailNotification(sortData(json, clientSideSorting.sortOrder, clientSideSorting.sortColumn));
            }
            // if (json && json.length > 0) {
            //     setIsEmailVerified(json[0].IsEmailVerified)
            // }
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    }

    const onHandleChangeStatus = async (e: any, accountProjectId: number, SystemEMailNotificationId: number, SystemEMailNotificationTypeId: number, AccountEMailNotificationPreferenceId: number) => {
        setIsLoading(true);
        const { checked } = e.target;
        let object = {
            AccountId: sessionAccountId,
            AccountProjectId: accountProjectId,
            SystemEMailNotificationid: SystemEMailNotificationId,
            SystemEMailNotificationType: "Project Level",
            SystemEMailNotificationTypeId: SystemEMailNotificationTypeId,
            Enabled: (checked ? true : false),
            AccountEMailNotificationPreferenceId: AccountEMailNotificationPreferenceId
        }
        try {
            const response = await fetchAPI(`api/v2/EmailNotifications/NotificationType`, 'PUT', object, true);
            const json = await response.json();
            const index = emailNotification.findIndex((item: any) => item.AccountEMailNotificationPreferenceId === AccountEMailNotificationPreferenceId);
            const newArray = [...emailNotification];
            newArray[index].Enabled = checked ? true : false;
            json.StatusCode === "200" && setemailNotification(newArray);
            json.StatusCode === "200" ? ShowToast('Success', "Email Preferencess Update Successfully", "success", "toast-top-right") :
                ShowToast('Error', "Email Preferencess Update Failed", "error", "toast-top-right");
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    }

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        setClientSideSorting({
            ...clientSideSorting,
            sortOrder: sortOrder,
            sortColumn: sortColumn
        });
        let sortedEmailNotification = [...emailNotification];
        setemailNotification(sortData(sortedEmailNotification, sortOrder, sortColumn));
    }

    return (
        <>
            {isLoading ?
                <Loader />
                :
                <div className="card card-custom admin-card">
                    <div className="card-header sticky-top bg-white">
                        <h3 className="card-title fw-bold headerTitle">
                            {/* {t('Email Notification Preferences')} */}
                            {getValueFromResource('Email Notification Preferences',dispatch, t)}
                            </h3>
                    </div>
                    {/* <div className='card-body py-3'> */}
                    <div className='card-Report-body py-3'>
                        <div className='table-responsive'>
                            <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                                <thead>
                                    <tr className='thHeading align-middle'>
                                        <th style={{ width: '80%' }}>
                                            {/* {t("EMail Notification")} */}
                                            {getValueFromResource('EMail Notification',dispatch, t)}
                                            {clientSideSorting.sortColumn === 'SystemEMailNotification' ?
                                                clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "SystemEMailNotification") }}>
                                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "SystemEMailNotification") }}>
                                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                </span>
                                                :
                                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "SystemEMailNotification") }}>
                                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "SystemEMailNotification") }}>
                                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                </>}
                                        </th>
                                        <th style={{ width: '20%' }}>
                                            {/* {t("Active")} */}
                                            {getValueFromResource('Active',dispatch, t)}

                                            </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {emailNotification.length > 0 && emailNotification.map((item: any) => {
                                        return (
                                            <tr key={item.AccountEMailNotificationPreferenceId}>
                                                <td className="tdHeight">
                                                    <a className='text-dark d-block'>
                                                        {item.SystemEMailNotification}
                                                    </a>
                                                </td>
                                                <td className="tdHeight">
                                                    <div className="form-check form-switch form-check-custom">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input custom-padding-right h-15px w-30px"
                                                            checked={item.Enabled ? true : false}
                                                            onChange={(e) => {
                                                                onHandleChangeStatus(e, item.AccountProjectId, item.SystemEMailNotificationId,
                                                                    item.SystemEMailNotificationTypeId, item.AccountEMailNotificationPreferenceId)
                                                            }}
                                                            // disabled={isEmailVerified ? false : true}
                                                            disabled={isEmailVerified ? false : true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                            {emailNotification.length === 0 &&
                                <div className=''>
                                    <p className='noDataFound'>
                                        {/* {t('No Record Found')} */}
                                        {getValueFromResource('No Record Found',dispatch, t)}
                                        </p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default ProjectEmailNotificationPreferences